import { render, staticRenderFns } from "./VFormItemAmountWithUnlimitOption.vue?vue&type=template&id=704dee1c&"
import script from "./VFormItemAmountWithUnlimitOption.vue?vue&type=script&lang=js&"
export * from "./VFormItemAmountWithUnlimitOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('704dee1c')) {
      api.createRecord('704dee1c', component.options)
    } else {
      api.reload('704dee1c', component.options)
    }
    module.hot.accept("./VFormItemAmountWithUnlimitOption.vue?vue&type=template&id=704dee1c&", function () {
      api.rerender('704dee1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VFormItemAmountWithUnlimitOption.vue"
export default component.exports